import React, { useState, useEffect } from 'react';
import { Input, Select, FormGroup, Textarea } from '../components/Form';
import { getAgendadores, submitDiario } from '../services/api';
import { logError } from '../lib/logError';
import { hojeSP } from '../lib/tz';


const INITIAL = {
    data: hojeSP(),
    nome: '',
    recebidos: '',
    respondidos: '',
    invalidos: '',
    desqualificados: '',
    aprendizados: '',
    desafios: '',
};

function DiarioSDR() {
    const [sdrs, setSdrs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState(INITIAL);

    useEffect(() => {
        setIsLoading(true);
        getAgendadores()
            .then(data => setSdrs(data.filter(m => m.cargo?.trim().toLowerCase() === 'sdr')))
            .catch(err => { logError(err, { page: 'DiarioSDR' }); setErrorMessage('Não foi possível carregar a lista de SDRs.'); })
            .finally(() => setIsLoading(false));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        if (value === '' || /^\d+$/.test(value)) setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSuccessMessage('');
        setErrorMessage('');
        try {
            const payload = {
                ...formData,
                recebidos: parseInt(formData.recebidos) || 0,
                respondidos: parseInt(formData.respondidos) || 0,
                invalidos: parseInt(formData.invalidos) || 0,
                desqualificados: parseInt(formData.desqualificados) || 0,
            };
            const response = await submitDiario(payload);
            if (response.success) {
                setSuccessMessage('Diário registrado com sucesso!');
                setFormData({ ...INITIAL, data: hojeSP() });
                window.scrollTo(0, 0);
            } else {
                setErrorMessage(response.error || 'Ocorreu um erro ao enviar o diário.');
            }
        } catch (error) {
            setErrorMessage(error?.message || 'Erro ao enviar o diário.');
            window.scrollTo(0, 0);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="page-header">
                <div className="page-header-left">
                    <div>
                        <div className="page-kicker">Diário</div>
                        <h1 className="page-title">Diário SDR</h1>
                    </div>
                </div>
                <div className="page-header-right">
                    <span className="chip chip-muted">{formData.data || 'hoje'}</span>
                </div>
            </div>

            <div className="page-body">
                {successMessage && <div className="alert alert-success">{successMessage}</div>}
                {errorMessage && <div className="alert alert-error">{errorMessage}</div>}

                <form onSubmit={handleSubmit}>
                    {/* Identificação */}
                    <div className="card" style={{ marginBottom: '1.25rem' }}>
                        <p className="section-label">Identificação</p>
                        <div className="grid-2">
                            <FormGroup label="Data" htmlFor="data">
                                <Input type="date" id="data" name="data" value={formData.data} onChange={handleChange} required />
                            </FormGroup>
                            <FormGroup label="Nome do SDR" htmlFor="nome">
                                <Select id="nome" name="nome" value={formData.nome} onChange={handleChange} required isLoading={isLoading}>
                                    <option value="">Selecione o SDR</option>
                                    {sdrs.map(s => <option key={s.nome} value={s.nome}>{s.nome}</option>)}
                                </Select>
                            </FormGroup>
                        </div>
                    </div>

                    {/* Métricas */}
                    <div className="card" style={{ marginBottom: '1.25rem' }}>
                        <p className="section-label">Métricas do Dia</p>
                        <div className="grid-4">
                            <FormGroup label="Recebidos" htmlFor="recebidos">
                                <Input type="number" min="0" id="recebidos" name="recebidos" value={formData.recebidos} onChange={handleNumberChange} placeholder="0" required />
                            </FormGroup>
                            <FormGroup label="Respondidos" htmlFor="respondidos">
                                <Input type="number" min="0" id="respondidos" name="respondidos" value={formData.respondidos} onChange={handleNumberChange} placeholder="0" required />
                            </FormGroup>
                            <FormGroup label="Inválidos" htmlFor="invalidos">
                                <Input type="number" min="0" id="invalidos" name="invalidos" value={formData.invalidos} onChange={handleNumberChange} placeholder="0" required />
                            </FormGroup>
                            <FormGroup label="Desqualificados" htmlFor="desqualificados">
                                <Input type="number" min="0" id="desqualificados" name="desqualificados" value={formData.desqualificados} onChange={handleNumberChange} placeholder="0" required />
                            </FormGroup>
                        </div>
                    </div>

                    {/* Reflexão */}
                    <div className="card">
                        <p className="section-label">Reflexão</p>
                        <FormGroup label="Aprendizados do Dia" htmlFor="aprendizados">
                            <Textarea id="aprendizados" name="aprendizados" value={formData.aprendizados} onChange={handleChange} placeholder="Descreva os principais aprendizados ou observações do dia..." rows={4} required />
                        </FormGroup>
                        <FormGroup label="Desafios do Dia" htmlFor="desafios">
                            <Textarea id="desafios" name="desafios" value={formData.desafios} onChange={handleChange} placeholder="Quais os principais desafios enfrentados hoje?" rows={4} required />
                        </FormGroup>
                        <div className="form-footer">
                            <button type="submit" className="pill pill-primary" disabled={isSubmitting}>
                                {isSubmitting ? 'Registrando...' : 'Registrar Diário SDR'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default DiarioSDR;
